




























































import { Component, Prop, Vue } from "vue-property-decorator";
import { DefaultOrderSorters } from "@/data/sorters/order";
import { ISorter, IFilter } from "@/models/tables";
import OrdersProvider from "@/components/app/global/orders/ordersProvider.vue";
import { IClient } from "@/models/clients";
import { DataModules } from "@/store/modules/data";
import { ISegmentTypes } from "@/data/enums/segments";

@Component({
  components: {
    OrdersProvider,
    "orders-table-view": () =>
      import("@/components/app/global/orders/ordersTableView.vue"),
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue")
  }
})
export default class OrdersListing extends Vue {
  // Props

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: () => () => [] })
  public availableFilters!: (vm: OrdersListing) => IFilter[];

  @Prop({ default: () => DefaultOrderSorters })
  public availableSorters!: (vm: OrdersListing) => ISorter[];

  @Prop({ default: () => () => ({}) })
  public manualFilters!: (
    vm?: OrdersListing
  ) => Record<string, string | number | boolean>;

  // Data

  public segmentType = ISegmentTypes.ORDER;
  public orderFilters: IFilter[] = [];
  public orderSorters: ISorter[] = [];

  public created() {
    this.orderSorters = this.availableSorters(this);
  }

  // Computed

  public get segmentApiProps() {
    return {
      with: this.$store.getters[`data/${DataModules.ORDERS}/withParam`]
    };
  }

  public get providerManualFilters() {
    return this.manualFilters();
  }
}
